import React, { useState } from 'react';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeySkeleton, faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { Divider } from 'primereact/divider';
import JSEncrypt from "jsencrypt";

const MetKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3prLK5rWvXhOfC8JyMImg
NWH1XaY8+pQGs5FVy0dAPcogNi7FJKQvjNOx2nNl4ESU1ShT3TNe69L8x45MR2zg
OGbgN1NXdCCYu7bsJlQUxWuu1jEqZVl5PKgz8JSrkk47kRUFHw2Ogb50nYhR9X0q
LaU+UZshu5UG/ut/gaSS8TStrHwGifYsVRJIytSldEWlUWtuh19dc7RHVhwd3nd5
lBqqJC3cy2va2rRjC0f/UwHCANfvOPMT1Kfe+9ygihQ8l9B199+kgzy1Z/loBRsr
mVttnyKF9qvjzXbk5ZaFznyAFOu0pdLf3Wqp0X7YPFV7K2tqBoLJACUpH2NSUDej
AgMBAAE=
-----END PUBLIC KEY-----`;

const ChangePasswordTab = ({ mainApi, userProfileId, toast, t }) => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(MetKey);

  const [passwordNow, setPasswordNow] = useState("");
  const [passwordNew, setPasswordNew] = useState("");
  const [passwordNewAgain, setPasswordNewAgain] = useState("");
  const [isShowPasswordNow, setIsShowPasswordNow] = useState(false);
  const [isShowPasswordNew, setIsShowPasswordNew] = useState(false);
  const [isShowPasswordNewAgain, setIsShowPasswordNewAgain] = useState(false);
  const [loadingPasswordUpdate, setLoadingPasswordUpdate] = useState(false);

  const handleMouseDownPasswordNow = () => setIsShowPasswordNow(true);
  const handleMouseUpPasswordNow = () => setIsShowPasswordNow(false);
  const handleMouseDownPasswordNew = () => setIsShowPasswordNew(true);
  const handleMouseUpPasswordNew = () => setIsShowPasswordNew(false);
  const handleMouseDownPasswordNewAgain = () => setIsShowPasswordNewAgain(true);
  const handleMouseUpPasswordNewAgain = () => setIsShowPasswordNewAgain(false);

  const hasPasswordChanges = () => {
    return passwordNow.trim() !== "" &&
      passwordNew.trim() !== "" &&
      passwordNewAgain.trim() !== "" &&
      passwordNew !== passwordNow;
  };

  const updateResetPassword = () => {
    if (!passwordNow || !passwordNew || !passwordNewAgain) {
      toast.current.show({
        severity: 'warn',
        summary: t("warning"),
        detail: t("passwordFieldsEmptyWarning"),
        life: 3000
      });
      return;
    }

    if (!hasPasswordChanges()) {
      toast.current.show({
        severity: 'warn',
        summary: t("warning"),
        detail: t("noChangesWarning"),
        life: 3000
      });
      return;
    } else if (passwordNow.length < 6 || passwordNew.length < 6 || passwordNewAgain.length < 6) {
      toast.current.show({
        severity: 'warn',
        summary: t("warning"),
        detail: t("passwordMinLengthWarning"),
        life: 3000
      });
      return;
    } else if (passwordNew !== passwordNewAgain) {
      toast.current.show({
        severity: 'warn',
        summary: t("warning"),
        detail: t("passwordsDoNotMatchWarning"),
        life: 3000
      });
      return;
    }

    try {
      setLoadingPasswordUpdate(true);
      let oldPassword = encrypt.encrypt(passwordNow);
      let newPassword = encrypt.encrypt(passwordNew);

      mainApi.apiMainChangePasswordGet(oldPassword, newPassword, userProfileId).then((response) => {
        if (response.data && response.data.Status === "Ok") {
          toast.current.show({
            severity: 'success',
            summary: t("successful"),
            detail: t("passwordChangeSuccess"),
            life: 3000
          });
          setPasswordNow("");
          setPasswordNew("");
          setPasswordNewAgain("");
        } else {
          toast.current.show({
            severity: 'error',
            summary: t("error"),
            detail: response.data && response.data.Error ? response.data.Error : t("errorOccurred"),
            life: 3000
          });
        }
        setLoadingPasswordUpdate(false);
      }).catch((error) => {
        console.log('updateResetPassword', error);
        toast.current.show({
          severity: 'error',
          summary: t("error"),
          detail: t("errorOccurred"),
          life: 3000
        });
        setLoadingPasswordUpdate(false);
      });
    } catch (error) {
      console.log('updateResetPassword', error);
      setLoadingPasswordUpdate(false);
    }
  };

  return (
    <div id="changePassrword">
      <Row>
        <Col lg="6">
          <Form.Label className="customInputLabel">{t('profile.changePassword.currentPassword')} </Form.Label>
          <InputGroup className="user-password-input-group w-100">
            <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
              <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
            </InputGroup.Text>
            <Form.Control className="userLoginPassword customRegisterInput"
              value={passwordNow}
              onChange={(e) => setPasswordNow(e.target.value)}
              type={isShowPasswordNow ? "text" : "password"}
              aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder={t('profile.changePassword.currentPasswordPl')} name="passwordNow" />
            <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
              onMouseDown={handleMouseDownPasswordNow}
              onMouseUp={handleMouseUpPasswordNow}
              onMouseLeave={handleMouseUpPasswordNow}>
              <FontAwesomeIcon icon={isShowPasswordNow ? faEye : faEyeSlash} />
            </InputGroup.Text>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          <Form.Label className="customInputLabel">{t('profile.changePassword.newPassword')}</Form.Label>
          <InputGroup className="user-password-input-group w-100">
            <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
              <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
            </InputGroup.Text>
            <Form.Control className="userLoginPassword customRegisterInput"
              value={passwordNew}
              onChange={(e) => setPasswordNew(e.target.value)}
              type={isShowPasswordNew ? "text" : "password"}
              aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder={t('profile.changePassword.newPasswordPl')} name="passwordNew" />
            <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
              onMouseDown={handleMouseDownPasswordNew}
              onMouseUp={handleMouseUpPasswordNew}
              onMouseLeave={handleMouseUpPasswordNew}>
              <FontAwesomeIcon icon={isShowPasswordNew ? faEye : faEyeSlash} />
            </InputGroup.Text>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          <Form.Label className="customInputLabel">{t('profile.changePassword.confirmNewPassword')}</Form.Label>
          <InputGroup className="user-password-input-group w-100">
            <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
              <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
            </InputGroup.Text>
            <Form.Control className="userLoginPassword customRegisterInput"
              value={passwordNewAgain}
              onChange={(e) => setPasswordNewAgain(e.target.value)}
              type={isShowPasswordNewAgain ? "text" : "password"}
              aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder={t('profile.changePassword.newAgainPasswordPl')} name="passwordNewAgain" />
            <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
              onMouseDown={handleMouseDownPasswordNewAgain}
              onMouseUp={handleMouseUpPasswordNewAgain}
              onMouseLeave={handleMouseUpPasswordNewAgain}>
              <FontAwesomeIcon icon={isShowPasswordNewAgain ? faEye : faEyeSlash} />
            </InputGroup.Text>
          </InputGroup>
        </Col>
      </Row>
      <Divider align="center"></Divider>
      <Row style={{ display: 'inline' }}>
        <Button slot="end" variant="dark" className="saveButton" onClick={updateResetPassword} disabled={loadingPasswordUpdate}>
          {loadingPasswordUpdate ? (
            <><FontAwesomeIcon icon={faSpinner} spin />{' '}{t('update')}</>
          ) : (
            t('update')
          )}
        </Button>
      </Row>
    </div>
  );
};

export default ChangePasswordTab;
